import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import Keycloak from 'keycloak-js';

// Si el backend rechaza un request con 401, el token ya no es válido server-side
// (expiró o fue revocado). Forzamos el login en vez de dejar la UI en un estado
// inconsistente con datos obsoletos (ej: volviendo con el botón atrás del navegador).
export const sessionExpiredInterceptor: HttpInterceptorFn = (req, next) => {
  const keycloak = inject(Keycloak);

  return next(req).pipe(
    catchError((error) => {
      if (error.status === 401) {
        keycloak.login();
      }
      return throwError(() => error);
    })
  );
};
